import { Injectable } from '@angular/core';

import { DataEntityWorkflow } from '@osos/shared/api';
import { FactoryBase } from '../../bases/factory/factory-base';
import { ParserFactory } from '../../services';

import { DataEntityWorkflowPresenterModel } from '@osos/shared/types';
import { DataEntityWorkflowParserService } from '../../parsers/data-entity-workflow-parser/data-entity-workflow-parser.service';

@Injectable()
export class DataEntityWorkflowFactoryService extends FactoryBase<
  DataEntityWorkflow,
  DataEntityWorkflowPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: DataEntityWorkflowParserService,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }
  createDataModel(
    presenter: DataEntityWorkflowPresenterModel,
  ): DataEntityWorkflow {
    //@TODO use presenter.specificationVersion
    const parser = this.getParser(
      DataEntityWorkflow,
      DataEntityWorkflowPresenterModel,
    );
    const result = parser.getDataModel(presenter);
    return result;
  }
  createPresenterModel(
    model: DataEntityWorkflow,
  ): DataEntityWorkflowPresenterModel {
    //@TODO use model.specificationVersion
    const parser = this.getParser(
      DataEntityWorkflow,
      DataEntityWorkflowPresenterModel,
    );
    const result = parser.getPresenterModel(model);
    return result;
  }
}
